import WrapperService from '@/modules/core/services/wrapper-service';

const API_URL = process.env.VUE_APP_ROOT_API + '/api/v1/cost-analysis';

const serviceName = "CostAnalysis-Service: ";

export default class CostAnalysisService {

  static async readFacilityAnalysis(id, successF, errorF) {
    await WrapperService.get(API_URL + '/facility/' + id, null, serviceName, successF, errorF);
  }

  static async readBuildAnalysis(id, successF, errorF) {
    await WrapperService.get(API_URL + '/building/' + id, null, serviceName, successF, errorF);
  }

  static async readCustomerAnalysis(id, successF, errorF) {
    await WrapperService.get(API_URL + '/customer/' + id, null, serviceName, successF, errorF);
  }

}